module.exports = __webpack_public_path__ + "img/undraw_uploading_go67.8de758a0.svg";